/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryWriteOffsDto as DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/WriteOffs/inventory-write-offs-dto';

export interface GetInventoryWriteOffs$Params {
  inventoryId: string;
  searchTerm?: string;
}

export function getInventoryWriteOffs(http: HttpClient, rootUrl: string, params: GetInventoryWriteOffs$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffsDto>> {
  const rb = new RequestBuilder(rootUrl, getInventoryWriteOffs.PATH, 'get');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.query('searchTerm', params.searchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffsDto>;
    })
  );
}

getInventoryWriteOffs.PATH = '/api/inventories/{inventoryId}/write-offs';
